define((require) => {
    "use strict";

    var _                       = require("underscore"),
        ImprovedView            = require("editor/zbone/ImprovedView"),
        LoggedInUserState       = require("shared/ui/user/LoggedInUserState"),
        PublishableState        = require("util/PublishableState"),
        template                = require("ui/experienceOverview/QuickViewGroupDetailsView.tpl"),
        Tooltip                 = require("ui/common/Tooltip"),
        URLBox                  = require("ui/common/URLBox"),
        UrlUtil                 = require("shared/util/UrlUtil");

    /**
     * Sub view used by the <tt>QuickView</tt> for displaying experience details, statistics etc.
     *
     * @cfg {ExperienceModel} model The experience model.
     *
     * @class QuickViewExperienceDetailsView
     */
    return ImprovedView.extend({

        _group: null,

        _isGroupPushed: null,

        template: template,

        regions: {},

        templateHelpers: function() {
            var isOneUnit = this._group.isOneUnit();

            return {
                isOneUnit: isOneUnit,
                spectatorMode: this.options.spectatorMode,
                isGroupPushed: this._isGroupPushed,
                // A hack to get the assigned assets for breakpoint group by checking isOneUnit, which is not the right way.
                // But right now we only have two type of groups, so it works fine.
                // This should be refactored if we have more then two group types later.
                assets: isOneUnit && this._getAssignedAssets(),
                groupType: this._group.getDashedType()
            };
        },

        ui: {
            toggleGroupData: ".toggle-group-data",
            assignedBreakpoints: ".assigned-breakpoints-container",
            toggleGroupURL: ".toggle-group-url",
            urlContainer: ".group-url-container",
            readableState: ".readable-state",
            currentGroupStatus: ".current-group-status",
            notPushedChangesWarning: ".not-pushed-changes-warning",
            pushedCheckMark: ".pushed-check-mark"
        },

        events: {
            "click @ui.toggleGroupData": "_toggleGroupData",
            "click @ui.toggleGroupURL": "_toggleGroupUrl"
        },

        initialize: function() {
            this._group = this.options.group;

            if (this._group) {
                this._isGroupPushed = this._group.hasAtLeastState(PublishableState.PUSHED);

                this.listenTo(this._group, "sync:state", function() {
                    this._updateState();
                });
            }
        },

        onRender: function() {
            if (this._group) {
                this._updateState();
                this._initializeURL();
            }

            Tooltip.add(this.ui.toggleGroupURL, {
                width: 230,
                placement: "top",
                html: true
            });
        },

        _getAssignedAssets: function() {
            var self = this,
                lowerBounds = this._getLowerBounds(),
                breakpointCollection = LoggedInUserState.get("companySettings").get("breakpoints"),
                naming = breakpointCollection.generateNaming(lowerBounds.length - 1);

            return _.map(lowerBounds, (breakpoint, index) => {
                var experience = self._group.getAssetByThreshold(breakpoint.get("threshold"));

                return [naming[index], breakpoint, experience];
            });
        },

        _getLowerBounds: function() {
            var breakpoints = this._group && this._group.getValues();

            if (!breakpoints.length) {
                breakpoints = this.lowerBoundsInSetting;
            }

            return _.sortBy(breakpoints, (breakpoint) => {
                return breakpoint.get("threshold");
            });
        },

        _updateState: function() {
            var pushed = this._group.hasAtLeastState(PublishableState.PUSHED),
                nonPushedChanges = this._group.isChangedAfterPush();

            this.ui.currentGroupStatus.toggleClass("changes", nonPushedChanges);
            this.ui.notPushedChangesWarning.toggle(nonPushedChanges);
            this.ui.pushedCheckMark.toggle(pushed && !nonPushedChanges);

            if (nonPushedChanges) {
                Tooltip.add(this.ui.notPushedChangesWarning, {
                    width: 170,
                    placement: "top",
                    html: true
                });
            }

            this.ui.readableState.html(this._group.getState().displayName);
        },

        _toggleGroupData: function() {
            if (this._isGroupPushed) {
                var open = !this.ui.assignedBreakpoints.is(":visible");

                this.ui.assignedBreakpoints.slideToggle(open);
                this.ui.toggleGroupData.toggleClass("open", open);
            }
        },

        _toggleGroupUrl: function(event) {
            if (this._isGroupPushed) {
                event.preventDefault();

                var open = !this.ui.urlContainer.is(":visible");

                this.ui.urlContainer.slideToggle(open);
                this.ui.toggleGroupURL.toggleClass("open", open);
            }
        },

        _initializeURL: function() {
            var urlBox = new URLBox({
                urlProvider: this._urlProvider.bind(this),
                helpText: "View your Group directly with this link.",
                project: this.options.project,
                triggerOrigin: "OpenGroupUrlButton"
            }).render();

            this.ui.urlContainer.html(urlBox.el);
        },

        _urlProvider: function() {
            return UrlUtil.getAbsoluteExperienceUrl(this.model.get("id"));
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/QuickViewGroupDetailsView.js